import { render, staticRenderFns } from "./InfoQuery.vue?vue&type=template&id=2dd7daab&scoped=true"
import script from "./InfoQuery.vue?vue&type=script&lang=js"
export * from "./InfoQuery.vue?vue&type=script&lang=js"
import style0 from "./InfoQuery.vue?vue&type=style&index=0&id=2dd7daab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7daab",
  null
  
)

export default component.exports